var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inner"},[_c('el-row',{staticClass:"onlyMobile"},[_c('el-col',[_c('h3',[_vm._v("Dokumentacja")])])],1),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(!_vm.loading)?_c('div',[_c('markdown-panel'),_c('markdown-html')],1):_vm._e()])],1),_c('back-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }